import React from "react";
import type { KeyFact } from "../../types/content";
type QuickAnswerProps = {
  id: string;
  question: string;
  answer: string;
  points: KeyFact[];
};
export function QuickAnswer({
  id,
  question,
  answer,
  points
}: QuickAnswerProps) {
  return <section className="border-b border-line bg-white py-8 lg:py-14" aria-labelledby={id} data-id="element-246" data-mp="2zakllisdz18y">
      <div className="mx-auto grid max-w-[1320px] gap-10 px-5 lg:grid-cols-2 lg:gap-16 lg:px-10" data-id="element-247" data-mp="2v7o8u8pj1zcx">
        <div data-id="element-248" data-mp="27hk5m2g941mg">
          <p className="text-sm font-bold text-rinnai" data-id="element-249" data-mp="27j523xm4lumy">QUICK ANSWER</p>
          <h2 id={id} className="mt-4 text-3xl font-bold tracking-[-0.04em] sm:text-4xl" data-id="element-250" data-mp="22js36ehzcx40">{question}</h2>
          <p className="mt-5 text-lg leading-8 text-muted" data-id="element-251" data-mp="2gjjo6z6wzdri">{answer}</p>
        </div>
        <dl className="grid auto-rows-fr gap-px self-start overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2" data-id="element-252" data-mp="2bi44bagh3dap">
          {points.map(point => <div key={point.label} className="flex flex-col justify-center bg-white p-5" data-id="element-253" data-mp="3mykbkghvinmh">
              <dt className="text-xs font-bold uppercase tracking-[0.06em] text-muted" data-id="element-254" data-mp="23pqzgg03h0l0">{point.label}</dt>
              <dd className="mt-2 text-base font-bold leading-6 text-ink" data-id="element-255" data-mp="27qst8hb8skfl">{point.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}